<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
        <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
      </div>
      <div class="content-body">
        <section id="offers-active">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5 class="content-header-title card-title">Consulta el listado de ofertas de trabajo que actualmente se encuentran publicadas.</h5>
              </div>
              <div class="table-responsive card-body">
                <div *ngIf="response?.data === null || response?.data.length === 0"
                  class="bs-callout-info callout-round callout-bordered mt-1">
                    <div class="media align-items-stretch">
                      <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                        <i class="la la-ban white font-medium-5"></i>
                      </div>
                      <div class="media-body p-1">
                        <h4 class="info">No hay ofertas publicadas</h4>
                        <p>Aún no hay registro de ofertas que se hayan validado para ser publicadas, por lo que no hay información que mostrar.
                        Si algún usuario ofertador ha creado ofertas de trabajo, consulta la información en la sección <b>Ofertas de trabajo</b>, 
                        en cuanto sean validadas por otro usuario administrador, podrás consultarlas aquí.
                        </p>
                      </div>
                    </div>
                </div>
  
                <table *ngIf="response?.data != null || response?.data.length > 0"
                class="table table-column table-hover">
                  <thead class="thead bg-blue1">
                    <tr>   
                      <th scope="col">
                        <h5 class="text-bold-600">Lugar</h5></th>                   
                      <th scope="col">
                        <h5 class="text-bold-600">Puesto</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Responsable</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Detalles</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">No. Postulantes</h5></th>
                      <th scope="col" class="col-sm-3">
                        <h5 class="text-bold-600">Estado de vacante</h5></th>
                      </tr>
                  </thead>
                  <tbody *ngFor="let oferta of response?.data;">
                    <tr class="ng-star-inserted">
                      <td scope="row">{{ oferta.empresa }}</td>
                      <th scope="row">{{ oferta.descripcionPuesto }}</th>
                      <td scope="row">{{ oferta.nombreResponsable }}</td>                       
                      <td scope="row" class="text-center">
                        <button type="button" class="btn btn-icon btn-primary mr-1" (click)="openDetailOffer(oferta?.idOferta)"
                        triggers="hover:click:hover" placement="top"
                        ngbPopover="Consulta información más detallada acerca de la oferta de trabajo. Entérate del perfil y los conocimientos solicitados, así como las responsabilidades del puesto, entre otros datos."
                        popoverTitle="Detalles de la Oferta">
                          <i class="feather ft-eye"></i>
                        </button>
                      </td>
                      <td scope="row">{{ oferta.numeroPostulantes }}</td>
                      <td scope="row">
                        <div *ngIf="oferta.semaforo == 'verde'" class="badge badge-success btn-block">
                          <i class="feather ft-user-plus font-medium-3"></i>
                          <span>  Vacante disponible</span>
                        </div>
                        <div *ngIf="oferta.semaforo == 'amarillo'" class="badge badge-warning btn-block">
                          <i class="feather ft-clock font-medium-3"></i>
                          <span>  Tiene postulantes</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
  
                <div *ngIf="response?.totalPages> 1"
                  class="d-flex justify-content-between p-2">
                  <div class="col-lg-6 col-md-12">
                    <nav aria-label="Navegador de páginas">
                      <ul class="pagination justify-content-star pagination-separate ">
                        <ngb-pagination 
                        [(page)]="currentPage" 
                        [collectionSize]="response?.totalRows" 
                        [pageSize]="response?.pageSize" 
                        (pageChange)="pageChange($event)"
                        class="d-flex justify-content-start"></ngb-pagination>
                      </ul>
                    </nav>              
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <br><br><br>
            </div>
          </div>
        </section>
        <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
      </div>
    </div>
  </div>
  